import { DocumentTypesEnum, LMNClaim } from '@/modules/MyDocuments/myDocuments.types';
import { baseStoreCreator } from '@/utils/store';

export interface LettersOfMedicalNecessityPopupState {
  name?: string;
  description?: string;
  documentType?: DocumentTypesEnum;
  employeeId?: string;
  claimIds?: string[];
  createdLMNId?: string;
  associatedClaims?: LMNClaim[];
  onError?: () => Promise<void>;
}

export const DEFAULT_VALUES: LettersOfMedicalNecessityPopupState = {
  name: undefined,
  description: undefined,
  documentType: undefined,
  employeeId: undefined,
  claimIds: [],
  createdLMNId: undefined,
  associatedClaims: [],
  onError: undefined,
};

export const useLettersOfMedicalNecessityPopupStore =
  baseStoreCreator<LettersOfMedicalNecessityPopupState>(DEFAULT_VALUES);

export default useLettersOfMedicalNecessityPopupStore;
